import * as actionTypes from "../actionTypes";
import uuid from "uuid";

export const pageAddDialog = openTime => ({
	type: actionTypes.PAGE_ADD_DIALOG,
	openTime,
});

export const pageRemoveDialog = openTime => ({
	type: actionTypes.PAGE_REMOVE_DIALOG,
	openTime,
});

export const pageSetWindowDimensions = (windowHeight, windowWidth) => ({
	type: actionTypes.PAGE_WINDOW_RESIZED,
	windowHeight,
	windowWidth,
});

export const pageSetErrorDialogOpen = open => ({
	type: actionTypes.PAGE_SET_ERROR_DIALOG_OPEN,
	open,
});

export const pageSetDescription = description => ({
	type: actionTypes.PAGE_SET_DESCRIPTION,
	description,
});

export const pageSetInitialRender = initialRender => ({
	type: actionTypes.PAGE_SET_INITIAL_RENDER,
	initialRender,
});

export const pageSetScheduledMaintenance = scheduledMaintenance => ({
	type: actionTypes.PAGE_SET_SCHEDULED_MAINTENANCE,
	scheduledMaintenance,
});

const pageSetToast = (id, message, iconName, displayTime, manualDismiss) => ({
	type: actionTypes.PAGE_SET_TOAST,
	displayTime,
	iconName,
	id,
	manualDismiss,
	message,
});

const pageRemoveToast = id => ({
	type: actionTypes.PAGE_REMOVE_TOAST,
	id,
});

const pageRemoveToasts = ids => ({
	type: actionTypes.PAGE_REMOVE_TOASTS,
	ids,
});

const pageSetToastVisible = (id, visible) => ({
	type: actionTypes.PAGE_SET_TOAST_VISIBLE,
	id,
	visible,
});

const pageSetToastsVisible = (ids, visible) => ({
	type: actionTypes.PAGE_SET_TOASTS_VISIBLE,
	visible,
	ids,
});

export const pageDismissToasts = ids => {
	return dispatch => {
		setTimeout(() => dispatch(pageRemoveToasts(ids)), 400);
		return dispatch(pageSetToastsVisible(ids, false));
	};
};

export const pageDismissAllToasts = () => {
	return (dispatch, getState) => {
		const state = getState();
		const toastIds = state.page.toasts.map(toast => toast.id);
		return dispatch(pageDismissToasts(toastIds));
	};
};

export const pageDismissToast = id => {
	return dispatch => {
		setTimeout(() => dispatch(pageRemoveToast(id)), 400);
		return dispatch(pageSetToastVisible(id, false));
	};
};

export const pageAddToast = (message, iconName, displayTime = 5600, manualDismiss = false) => {
	return dispatch => {
		const id = uuid.v4();

		setTimeout(() => dispatch(pageSetToastVisible(id, true)), 100);

		if (isFinite(displayTime)) {
			setTimeout(() => dispatch(pageSetToastVisible(id, false)), displayTime);
			setTimeout(() => dispatch(pageRemoveToast(id)), displayTime + 400);
		}

		dispatch(pageSetToast(id, message, iconName, displayTime, manualDismiss));

		return id;
	};
};

export const pageSetServiceUnavailable = serviceUnavailable => ({
	type: actionTypes.PAGE_SET_SERVICE_UNAVAILABLE,
	serviceUnavailable,
});

export const pageSetClientOutdated = clientOutdated => ({
	type: actionTypes.PAGE_SET_CLIENT_OUTDATED,
	clientOutdated,
});

export const pageSetClientUnauthorized = clientUnauthorized => ({
	type: actionTypes.PAGE_SET_CLIENT_UNAUTH,
	clientUnauthorized,
});

export const pageSetSIPromise = siPromise => ({
	type: actionTypes.PAGE_SET_SI_PROMISE,
	siPromise,
});
